<template>
  <div>
    <div :class="$style.dropbox">
      <img
        :class="$style.previewImg"
        :src="applicationLogoUrl"
      >
    </div>
    <a
      v-if="isDefaultLogoUrl"
      :class="$style.link"
      href="javascript:void(0);"
      @click.prevent="showLogoUploadModal"
    >
      replace logo
    </a>
    <a
      v-else
      :class="$style.link"
      href="javascript:void(0);"
      @click.prevent="restoreDefaultLogoUrl"
    >
      restore default logo
    </a>
    <LogoUploadModal
      :handleCancel="handleLogoUploadCancel"
      :visible="logoUploadModalVisible"
    />
  </div>
</template>
<script>
import { StoreModelMap } from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import ItemTypeConstants from 'client/util/Constants/ItemTypeConstants';
import LogoUploadModal from 'client/components/Applications/LogoUploadModal';

const { ItemTypeConsts } = ItemTypeConstants;
const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'ImageUploader',

  components: {
    LogoUploadModal,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data: () => ({
    logoUploadModalVisible: false,
  }),

  computed: {
    ...mapGetters(applicationModel, [
      'logoUrl',
      'templateLogoUrl',
    ]),

    ...mapState(applicationModel, [
      'appLogo',
      'isDefaultLogoRestored',
    ]),

    applicationLogoUrl() {
      if (this.isDefaultLogoRestored && !this.appLogo) {
        return this.templateLogoUrl;
      }
      return (this.appLogo && this.appLogo.imageUrl) || this.logoUrl;
    },

    isDefaultLogoUrl() {
      const appLogoUrl = this.applicationLogoUrl;
      return appLogoUrl === this.templateLogoUrl;
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    ...mapActions(applicationModel, [
      'setApplicationLogo',
      'setIsDefaultLogoRestored',
    ]),

    handleLogoUploadCancel() {
      this.logoUploadModalVisible = false;
    },

    restoreDefaultLogoUrl() {
      this.setApplicationLogo(null);
      this.setIsDefaultLogoRestored(true);

      if (this.item.logo.url) {
        this.setItemField({ key: 'logo', value: { url: this.templateLogoUrl } });
      }
    },

    showLogoUploadModal() {
      this.logoUploadModalVisible = true;
    },
  },
};
</script>
<style module>
@value (greyLight9) from '~css/colors.css';

.dropbox {
  border: 2px dashed greyLight9;
  border-radius: 3px;
  box-sizing: content-box;
  height: 81px;
  margin-top: 20px;
  position: relative;
  text-align: center;
  transition: all 0.3s linear;
  width: 20.6em;
}

.link {
  color: inherit !important;
  cursor: pointer;
  text-decoration: underline !important;
}

.previewImg {
  border: inset 10px transparent !important;
  height: 100%;
  object-fit: contain;
  width: 100%;
}
</style>
